/* GRIT+TONIC Club Ordering Portal
   Category tabs on the club shop page. Display filtering only:
   access control is handled server-side by Locksmith, never here. */
(function () {
  function initTabs(root) {
    var tabs = root.querySelectorAll('[data-club-tab]');
    var items = root.querySelectorAll('[data-club-tags]');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-club-tab');
        tabs.forEach(function (t) {
          t.setAttribute('aria-pressed', t === tab ? 'true' : 'false');
        });
        items.forEach(function (item) {
          var tags = ' ' + (item.getAttribute('data-club-tags') || '') + ' ';
          var show = key === 'all' || tags.indexOf(' ' + key + ' ') !== -1;
          item.hidden = !show;
        });
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-club-products]').forEach(initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
